module.exports = __webpack_public_path__ + "static/media/BannerRankingMobile.88d58c18.webp";